import React from "react";

export const LogoMark = ({ size = 36, className = "" }) => (
  <span
    className={`inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full ${className}`}
    style={{
      width: size,
      height: size,
      background: "#F3ECDC",
      border: "1px solid var(--mn-glass-border)",
      boxShadow: "0 0 14px rgba(212,175,55,0.25)",
    }}
  >
    <img src="/logo-mark.png" alt="Mother Nature emblem" width={size} height={size} className="h-full w-full object-cover" />
  </span>
);

export const Logo = ({ size = 36 }) => (
  <span className="flex items-center gap-2.5">
    <LogoMark size={size} />
    <span className="leading-none">
      <span className="block font-serif text-lg tracking-wide" style={{ color: "var(--mn-text)" }}>
        Mother Nature
      </span>
      <span className="block font-mono text-[0.55rem] tracking-[0.3em] uppercase" style={{ color: "var(--mn-gold)" }}>
        Ancient wisdom · Modern science
      </span>
    </span>
  </span>
);
